import React from 'react';
import { CostDashboard } from '../components/CostDashboard/CostDashboardClean';

const CostManagementPage: React.FC = () => {
  return <CostDashboard />;
};

export default CostManagementPage;
